<template>
  <Flex
    direction="column"
    fullWidth
    v-test="'tw-page-profile'"
  >
    <Flex
      direction="column"
      :gap="0.25"
    >
      <BaseHeading size="l">
        {{ $t('admin.treatwell.pages.profile.heading') }}
      </BaseHeading>
      <BaseText color="secondary">
        {{ $t('admin.treatwell.pages.profile.subheading') }}
      </BaseText>
    </Flex>
    <BaseCard :heading="$t('admin.treatwell.pages.profile.card_heading')">
      <template #header>
        <BaseText
          v-if="hasActiveVenue && treatwellVenue?.url"
          :href="treatwellVenue.url"
        >
          {{ $t('admin.treatwell.pages.dashboard.view_page') }}
        </BaseText>
      </template>
      <ProfileTasks
        :treatwellVenue="treatwellVenue"
        :enableSection="enableSection"
        :updated="updated"
      />
    </BaseCard>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useTreatwellStore } from '@/stores/treatwell';
import type { TreatwellVenue } from '@/types';
import ProfileTasks from '../tasks/ProfileTasks.vue';
import type { UpdatedTasks } from './types';

// What clients see on the salon's marketplace page (later also product brands)
defineProps<{
  treatwellVenue: Partial<TreatwellVenue> | null;
  enableSection: boolean;
  updated: UpdatedTasks;
}>();

const { hasActiveVenue } = storeToRefs(useTreatwellStore());
</script>
